import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function AdminReasoningQuestions() {

  const nav = useNavigate();

  // ================= DATA =================
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  // ================= FORM STATE =================
  const [form, setForm] = useState({
    class_id: "",
    subject_id: "",
    category: "reasoning",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    correct: "A"
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // ================= LOAD CLASSES & SUBJECTS =================
  useEffect(() => {
    loadMeta();
  }, []);

  const loadMeta = async () => {
    try {
      const [cRes, sRes] = await Promise.all([
        api.get("/admin/classes"),
        api.get("/admin/subjects")
      ]);
      setClasses(cRes.data || []);
      setSubjects(sRes.data || []);
    } catch (err) {
      alert("Failed to load classes / subjects");
    }
  };

  // ================= SUBMIT =================
  const submit = async () => {
    try {
      if (!form.class_id) return alert("Select class");
      if (!form.subject_id) return alert("Select subject");
      if (!image) return alert("Image required");

      const fd = new FormData();
      Object.keys(form).forEach(k => fd.append(k, form[k]));
      fd.append("image", image);

      setLoading(true);

      await api.post("/admin/reasoning/question", fd);

      alert("✅ Reasoning question added");

      // reset
      setForm({
        class_id: "",
        subject_id: "",
        category: "reasoning",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct: "A"
      });
      setImage(null);

    } catch (err) {
      console.error(err);
      alert("❌ Failed to add reasoning question");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 30 }}>
      <h2>🧠 Add Reasoning Question</h2>

      {/* CLASS */}
      <select
        value={form.class_id}
        onChange={e =>
          setForm({ ...form, class_id: e.target.value, subject_id: "" })
        }
        style={input}
      >
        <option value="">Select Class</option>
        {classes.map(c => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>

      {/* SUBJECT */}
      <select
        value={form.subject_id}
        onChange={e => setForm({ ...form, subject_id: e.target.value })}
        style={input}
      >
        <option value="">Select Subject</option>
        {subjects
          .filter(s => s.class_id === Number(form.class_id))
          .map(s => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
      </select>

      {/* IMAGE */}
      <input
        type="file"
        accept="image/*"
        onChange={e => setImage(e.target.files[0])}
        style={input}
      />

      {/* OPTIONS */}
      {["option_a", "option_b", "option_c", "option_d"].map(opt => (
        <input
          key={opt}
          placeholder={opt.toUpperCase()}
          value={form[opt]}
          onChange={e => setForm({ ...form, [opt]: e.target.value })}
          style={input}
        />
      ))}

      {/* CORRECT */}
      <select
        value={form.correct}
        onChange={e => setForm({ ...form, correct: e.target.value })}
        style={input}
      >
        <option value="A">A</option>
        <option value="B">B</option>
        <option value="C">C</option>
        <option value="D">D</option>
      </select>

      <button onClick={submit} disabled={loading} style={btn}>
        {loading ? "Saving..." : "Save Reasoning Question"}
      </button>

      <br /><br />

      <button onClick={() => nav("/admin/reasoning/list")} style={btnSecondary}>
        📋 View Reasoning Questions
      </button>
    </div>
  );
}

// ================= STYLES =================
const input = {
  width: "100%",
  padding: 12,
  margin: "8px 0",
  borderRadius: 8,
  border: "1px solid #cbd5e1"
};

const btn = {
  padding: "12px 24px",
  background: "#2563eb",
  color: "white",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  marginTop: 12
};

const btnSecondary = {
  padding: "10px 20px",
  background: "#e5e7eb",
  border: "1px solid #d1d5db",
  borderRadius: 8,
  cursor: "pointer"
};
